<script>
import axios from 'axios'

export default {
  name: 'GeolocationService',
  methods: {
    getLocationInfo () {
      return axios.get('https://ipinfo.io?token=944a83861e74e9')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/GeolocationService.vue